/**
 * Format a numeric price as a CHF string.
 * @param {number|null|undefined} price - The numeric price
 * @param {Object} [options] - Formatting options
 * @param {boolean} [options.showCurrency=true] - Whether to show "CHF" prefix
 * @param {number} [options.decimals=2] - Number of decimal places
 * @returns {string} Formatted price string, e.g. "CHF 10.77" or "10.77"
 */
export function formatPrice(price, options = {}) {
  const { showCurrency = true, decimals = 2 } = options;
  if (price === null || price === undefined || isNaN(price)) return showCurrency ? 'CHF —' : '—';
  const formatted = Number(price).toFixed(decimals);
  return showCurrency ? `CHF ${formatted}` : formatted;
}
